/**
 * i18next namespaces for translation
 */
export var TranslationNamespace;
(function (TranslationNamespace) {
    /**
     * Configuration data translations.
     *
     * ⚠️ Loaded from separate endpoint
     */
    TranslationNamespace["Configuration"] = "configuration";
    /**
     * UI translations for Configuration Renderer
     */
    TranslationNamespace["ConfigurationRenderer"] = "ConfigurationRenderer";
    /**
     * UI translations for Layout Editor
     */
    TranslationNamespace["LayoutEditor"] = "LayoutEditor";
    /**
     * UI translations for Data Manager
     */
    TranslationNamespace["DataManager"] = "DataManager";
    /**
     * UI translations for CPQ
     */
    TranslationNamespace["CPQ"] = "CPQ";
    /**
     * UI translations for Document Editor
     */
    TranslationNamespace["DocumentEditor"] = "DocumentEditor";
    /**
     * UI translations for TypecodeBuilder
     */
    TranslationNamespace["TypecodeBuilder"] = "TypecodeBuilder";
    /**
     * UI translations for the custom app in projects
     */
    TranslationNamespace["CustomApp"] = "CustomApp";
})(TranslationNamespace || (TranslationNamespace = {}));
//# sourceMappingURL=TranslationNamespace.js.map